
const HomeProducts =[
    {
        id:1,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'./img/jumpsuit.jpg'
    },
    {
        id:2,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'./img/dress.jpg'
    },
    {
        id:3,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/blazer.jpg'
    }, 

    {
        id:4,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo.jpg'
    }, 
    {
        id:5,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'./img/twopiece.jpg'
    },

    {
        id:6,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'./img/trouser.jpg'
    }, 

]

export default HomeProducts